import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTableExamAim = props => {
    const { aim, appointed, loc } = props;
    return (
        <table className="prm-table prm-table-exam-aim">
            <tbody>
                <tr>
                    <td className="prm-title">{loc("report.exam.aim")}</td>
                    <td className="prm-data ">{aim?.val}</td>
                </tr>
                <tr>
                    <td className="prm-title">{loc("report.exam.appointed")}</td>
                    <td className="prm-data ">{appointed?.val}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTableExamAim);
